// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardCustomCreateBody = {
  poolId: string;
  kind: "medal" | "trophy";
  name: string;
  color:
    | "color1"
    | "color2"
    | "color3"
    | "color4"
    | "color5"
    | "color6"
    | "color7"
    | "color8";
};

export type typeAwardCustomCreateOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { awardTypeId: string };
};

export type typeAwardCustomCreateOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomCreateOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardCustomCreateOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardCustomCreateBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    kind: { type: "string", enum: ["medal", "trophy"] },
    name: { type: "string", maxLength: 3000, minLength: 1 },
    color: {
      type: "string",
      enum: [
        "color1",
        "color2",
        "color3",
        "color4",
        "color5",
        "color6",
        "color7",
        "color8",
      ],
    },
  },
  required: ["poolId", "kind", "name", "color"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardCustomCreate(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardCustomCreateBody);
  }

  return async function postAwardCustomCreate(
    payload: typeAwardCustomCreateBody,
  ): Promise<typeAwardCustomCreateOutput200 | typeAwardCustomCreateOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardCustomCreate" failed before calling the network. #045a4bc1e45a`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#045a4bc1e45a" },
        },
        data: null,
      } as typeAwardCustomCreateOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/custom-create`,
      httpMethod: "POST",
      options,
    })) as typeAwardCustomCreateOutput200 | typeAwardCustomCreateOutput400;
  };
}
